import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AlertService } from '../../services/alert.service';
import * as actions from './actions';
import { of } from 'rxjs';
import { switchMap, catchError, map } from 'rxjs/operators';
import { InterviewService } from '../../services/interviews.service';

@Injectable()
export class InterviewsEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private interviewService: InterviewService,
    private alertService: AlertService
  ) {}

  getInterviews$ = createEffect(() => this.actions$.pipe(
    ofType<actions.GetInterviewsAction>(actions.GET_INTERVIEWS_ACTION),
    switchMap(action =>
      this.interviewService.getInterviews(action.includePast).pipe(
        map(result => new actions.GetInterviewsActionSuccess(result)),
        catchError(error => {
          this.alertService.error(error);
          return of(new actions.GetInterviewsActionError(error));
        })
      )
    )
  ));

  getInterviewDetails$ = createEffect(() => this.actions$.pipe(
    ofType<actions.GetInterviewDetailsAction>(actions.GET_INTERVIEW_DETAILS_ACTION),
    switchMap(action =>
      this.interviewService.getInterviewDetails(action.id).pipe(
        map(result => new actions.GetInterviewDetailsActionSuccess(result)),
        catchError(error => {
          this.alertService.error(error);
          return of(new actions.GetInterviewDetailsActionError(error));
        })
      )
    )
  ));

  createInterview$ = createEffect(() => this.actions$.pipe(
    ofType<actions.CreateInterviewAction>(actions.CREATE_INTERVIEW_ACTION),
    switchMap(action =>
      this.interviewService.createInterview(action.model).pipe(
        map(result => {
            this.alertService.success('Interview created successfully');
            return new actions.CreateInterviewActionSuccess(result);
        }),
        catchError(error => {
          this.alertService.error(error);
          return of(new actions.CreateInterviewActionError(error));
        })
      )
    )
  ));

  updateInterview$ = createEffect(() => this.actions$.pipe(
    ofType<actions.UpdateInterviewAction>(actions.UPDATE_INTERVIEW_ACTION),
    switchMap(action =>
      this.interviewService.updateInterview(action.model).pipe(
        map(result => {
            this.alertService.success('Interview updated successfully');
            return new actions.UpdateInterviewActionSuccess(result);
        }),
        catchError(error => {
          this.alertService.error(error);
          return of(new actions.UpdateInterviewActionError(error));
        })
      )
    )
  ));

  createUpdateInterviewRequest$ = createEffect(() => this.actions$.pipe(
    ofType<actions.CreateUpdateInterviewRequestAction>(actions.CREATE_UPDATE_INTERVIEW_REQUEST),
    switchMap(action =>
      this.interviewService.createUpdateInterviewRequest(action.model, action.interviewId).pipe(
        switchMap(result => of(new actions.GetInterviewDetailsAction(action.interviewId))),
        catchError(error => {
          this.alertService.error(error);
          return of(new actions.CreateUpdateInterviewRequestActionError(error));
        })
      )
    )
  ));
}
